import { ArchetypeDefinition } from '../../archetypeTypes';

export const SELF_ARCHETYPES: ArchetypeDefinition[] = [
    {
        key: 'self',
        name: 'Self',
        description: 'Integration and balance among opposites; emergent wholeness.',
        category: 'Self',
        tags: ['integration', 'balance', 'wholeness'],
        weights: { stability: 0.3, fractalDimension: 0.25, averageNodeEnergy: 0.2, edgeCount: 0.15, linguisticComplexity: 0.1 }
    },
    {
        key: 'persona',
        name: 'Persona',
        description: 'Adapted interface to the world; social presentation.',
        category: 'Self',
        tags: ['mask', 'adaptation', 'social'],
        weights: { linguisticComplexity: 0.35, stability: 0.3, nodeCount: 0.2, voicePitch: 0.15 }
    },
    {
        key: 'anima',
        name: 'Anima',
        description: 'Inner relatedness, receptivity, and affective attunement.',
        category: 'Self',
        tags: ['relatedness', 'receptivity', 'affect'],
        weights: { breathingQuality: 0.35, voicePitch: 0.25, stability: 0.2, linguisticComplexity: 0.2 }
    },
    {
        key: 'animus',
        name: 'Animus',
        description: 'Inner assertiveness, structure, and directed logos.',
        category: 'Self',
        tags: ['assertiveness', 'structure', 'logos'],
        weights: { stability: 0.3, linguisticComplexity: 0.25, edgeCount: 0.25, energyLevel: 0.2 }
    }
];


